import React, { Component } from "react";
import DigiLoader from "../../Assets/Logo/DigiLoader.gif";

class FormLoader extends Component {
  render() {
    return (
      <img
        src={DigiLoader}
        alt="Loader"
        style={{ marginLeft: 10, width: 30, height: 30 }}
      />
    );
  }
}

export default FormLoader;
